import React from 'react';
import {Col, Row, Tab, Table, Tabs} from "react-bootstrap";
import moment from "moment";
import numberFormat from "../../../helpers/numberFormat";
import _ from "lodash"


const SpecialSilkKayarRender = ({data}) => {
  return (
    <>
      Период из документа {data.silkPeriod}
      <Row>
        <Col>
          <Tabs defaultActiveKey="correct">
            <Tab
              eventKey="correct"
              title={`Правильные (${data.correct.length})`}
            >
              {renderStandartTable(data.correct, true)}
            </Tab>
            <Tab
              eventKey="kayarMissing"
              title={`Нет в ЭСФ (${data.kayarMissing.length})`}
            >
              {renderStandartTable(data.kayarMissing, )}
            </Tab>
            <Tab
              eventKey="silkMissing"
              title={`Нет в Шелке (${data.silkMissing.length})`}
            >
              {renderStandartTable(data.silkMissing, )}
            </Tab>
            <Tab
              eventKey="diff"
              title={`Отличаются (${data.diff.length})`}
            >
              <Table striped hover>
                <thead>
                <tr>
                  <td >ЭСФ</td>
                  <td >Билет</td>
                  <td >Выписан</td>
                  <td colSpan={2} className={'text-center'}>Комиссия</td>
                  <td >НДС</td>
                </tr>
                <tr>
                  <td/>
                  <td/>
                  <td/>
                  <td>Каяр</td>
                  <td>Шелк</td>
                  <td/>
                </tr>
                </thead>
                <tbody>
                {data.diff.map((u, index) => {
                  return (
                    <tr key={index}>
                      <td>{u.code}</td>
                      <td>
                        {u.airline} {u.ticketNumber}
                      </td>
                      <td>{moment.utc(u.issueDate).format("DD.MM.YYYY")}</td>
                      <td>{numberFormat(u.commission.kayar)}</td>
                      <td>{numberFormat(u.commission.silk)}</td>
                      <td>{numberFormat(u.nds)}</td>
                    </tr>
                  );
                })}
                <tr>
                  <td colSpan={3}>
                    <b>Итого</b>
                  </td>
                  <td>
                    <b>
                      {numberFormat(_.sumBy(data.diff, r => r.commission.kayar))}
                    </b>
                  </td>
                  <td>
                    <b>
                      {numberFormat(_.sumBy(data.diff, r => r.commission.silk))}
                    </b>
                  </td>
                  <td>
                    <b>
                      {numberFormat(_.sumBy(data.diff, 'nds'))}
                    </b>
                  </td>
                </tr>
                </tbody>
              </Table>
            </Tab>
            {data.silkDuplicates.length > 0 && <Tab
              eventKey="silkDuplicates"
              title={`Дубли в Шелке (${data.silkDuplicates.length})`}
            >
              {renderStandartTable(data.silkDuplicates, )}
            </Tab>}
            {data.kayarDuplicates.length>0 && <Tab
              eventKey="kayarDuplicates"
              title={`Дубли в Шелке (${data.kayarDuplicates.length})`}
            >
              {renderStandartTable(data.kayarDuplicates)}
            </Tab>}
          </Tabs>
        </Col>
      </Row>
      </>
  );
};

const renderStandartTable = (data, nds)=>{
  return <Table striped hover>
    <thead>
    <tr>
      {nds && <td>ЭСФ</td>}
      <td>Билет</td>
      <td>Выписан</td>
      <td>Комиссия</td>
      {nds && <td>НДС</td>}
    </tr>
    </thead>
    <tbody>
    {data.map((u, index) => {
      return (
        <tr key={index}>
          {nds && <td>{u.code}</td>}
          <td>
            {u.airline} {u.ticketNumber}
          </td>
          <td>{moment.utc(u.issueDate).format("DD.MM.YYYY")}</td>
          <td>{numberFormat(u.commission)}</td>
          {nds && <td>{numberFormat(u.nds)}</td>}
        </tr>
      );
    })}
    <tr>
      <td colSpan={nds ? 3: 2}>
        <b>Итого</b>
      </td>
      <td>
        <b>
          {numberFormat(_.sumBy(data, 'commission'))}
        </b>
      </td>
      {nds && <td>
        <b>
          {numberFormat(_.sumBy(data, 'nds'))}
        </b>
      </td>}
    </tr>
    </tbody>
  </Table>
}

export default SpecialSilkKayarRender;
